import React from 'react';
/*----------------------------------
- LANDING PAGE (PUBLIC)
----------------------------------*/

/*----------------------------------
- DEPENDENCES
----------------------------------*/

// Npm packages

// Landing (ported from `../landing/src` workspace folder)
import { App as LandingApp } from '@/client/pages/landing/app';
import type { LandingHeaderDomainsNavigation } from '@/client/catalogs/landing/pageContent';
import { LANDING_WEBSITE_LINKS } from '@/client/catalogs/landing/publicLinks';
import { EMPTY_LANDING_NAVIGATION } from '@/client/pages/landing/types';
import type { InitialData, LandingStats } from '@/client/pages/landing/types';
import type { HomeDomainsPreviewData } from '@/client/pages/landing/lib/homeDomainsPreview';

// Styles (Tailwind CSS v4)
import '../shared.css';

/*----------------------------------
- COMPONENT
----------------------------------*/

type LandingPageProps = {
    stats: LandingStats;
    navigation?: LandingHeaderDomainsNavigation;
    /** The real row preview, or null when the cached search is not renderable. */
    domainsPreview?: HomeDomainsPreviewData | null;
};

const LandingPage = ({
    stats,
    navigation = EMPTY_LANDING_NAVIGATION,
    domainsPreview = null,
}: LandingPageProps) => {
    /*----------------------------------
    - INIT
    ----------------------------------*/

    /**
     * Minimal static data to make the landing render inside the 5HTP app.
     * Intentionally avoids request/referrer-derived logic (per task scope).
     */
    const initialData: InitialData = {
        stats,
        links: LANDING_WEBSITE_LINKS,
        navigation,
        domainsPreview,
    };

    /*----------------------------------
    - RENDER
    ----------------------------------*/

    return <LandingApp initialData={initialData} />;
};

export default LandingPage;
